module.exports = __webpack_public_path__ + "img/ellipse_bgr.db4824eb.svg";